import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import StaffService from "../../services/staff.service";

export const getStaff = createAsyncThunk(
  "staff/getStaff",
  async (params, thunkAPI) => {
    try {
      const response = await StaffService.getStaff(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addStaff = createAsyncThunk(
  "staff/addStaff",
  async (data, thunkAPI) => {
    try {
      const response = await StaffService.addStaff(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const updateStaff = createAsyncThunk(
  "staff/updateStaff",
  async (payload, thunkAPI) => {
    try {
      const response = await StaffService.editStaff(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const deleteStaff = createAsyncThunk(
  "staff/deleteStaff",
  async (id, thunkAPI) => {
    try {
      await StaffService.deleteStaff(id);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

/* =================== State =================== */

const initialState = {
  loading: false,
  error: null,
  staffList: [],
  updateSuccess: false,
};

/* =================== Slice =================== */

const staffSlice = createSlice({
  name: "staff",
  initialState,
  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder

      /* ---------- Get ---------- */
      .addCase(getStaff.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getStaff.fulfilled, (state, action) => {
        state.loading = false;
        state.staffList = action.payload?.staff || [];
      })
      .addCase(getStaff.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Add ---------- */
      .addCase(addStaff.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addStaff.fulfilled, (state, action) => {
        state.loading = false;
        const newHotel =
          action.payload?.data ||
          action.payload?.staff ||
          action.payload;

        if (newHotel) {
          state.staffList.unshift(newHotel);
        }
      })
      .addCase(addStaff.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Update ---------- */
      .addCase(updateStaff.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.updateSuccess = false;
      })
      .addCase(updateStaff.fulfilled, (state, action) => {
        state.loading = false;
        state.updateSuccess = true;

        const updated =
          action.payload?.data || action.payload?.staff;

        if (updated?._id) {
          const index = state.staffList.findIndex(
            (item) => item._id === updated._id
          );
          if (index !== -1) {
            state.staffList[index] = updated;
          }
        }
      })
      .addCase(updateStaff.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Delete ---------- */
      .addCase(deleteStaff.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteStaff.fulfilled, (state, action) => {
        state.loading = false;
        state.staffList = state.staffList.filter(
          (item) => item._id !== action.payload
        );
      })
      .addCase(deleteStaff.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetUpdateStatus } = staffSlice.actions;
export default staffSlice.reducer;
